export default __webpack_public_path__ + "static/media/florencia-ricca-3.b4e46b92.webp";